import React, { useState } from 'react'
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { text_convert_lower } from '../../helpers/GenericHelpers';
import { embeddedModelTypes, engineTypes, openAITypes, openSourceTypes } from '../../models/SharedModel';

type Props = {
  toggleSettingsModal?: Function;
  formValues: any;
  setFormValues: Function;
  addConfig: Function;
}

const Settings = (props: Props) => {

  const { toggleSettingsModal, formValues, setFormValues, addConfig } = props;
  const setValues = (value: any, field: string) => {
    if (field === 'engine') {
      if(value==='open_ai'){
        setModels(engineModels[0]?.models)
        setFormValues((prev: any) => ({
          ...(prev ?? {}),
          model_name: engineModels[0]?.models[0],
        }));
      }else if(value==='open_source'){
        setModels(engineModels[1]?.models)
        setFormValues((prev: any) => ({
          ...(prev ?? {}),
          model_name: engineModels[1]?.models[0],
        }));
      }
      // if (field === 'engine') {
      // if(value==='Openai'){
      //   setModels(engineModels[0]?.models)
      // }else if(value==='mistral AI'){
      //   setModels(engineModels[1]?.models)
      // }
    }

    setFormValues((prev: any) => {
      if (field === 'temperature') {
        return { ...prev, [field]: value / 10 }
      }
      return { ...prev, [field]: value };
    });
  };

  const engines = Object.values(engineTypes)
  const displayEngines = () => {
    return engines?.map((each: any) => {
      return (
        <option value={each} key={each}>
          {text_convert_lower(each)}
        </option>
      );
    });
  }

  const engineModels =
  [
    { engine: engineTypes.OPEN_AI, models: Object.values(openAITypes)},
    { engine: engineTypes.OPEN_SOURCE, models: Object.values(openSourceTypes) }
  ]
  const [models, setModels] = useState<any>(engineModels[0]?.models)
  const displayModels = () => {
    return models?.map((each: any) => {
      return (
        <option value={each} key={each}>
          {text_convert_lower(each)}
        </option>
      );
    });
  }

  const embeddedModels = Object.values(embeddedModelTypes)
  const displayEmbeddedModels = () => {
    return embeddedModels?.map((each: any) => {
      return (
        <option value={each?.value} key={each?.value}>
          {text_convert_lower(each?.label)}
        </option>
      );
    });
  }

  const configSubmit = () => {
    addConfig(formValues)
    // alert(JSON.stringify(formValues))
  }
  return (
    <div className="temp-attr-selected-form">
      <Form className="temp-attr-item temp-attr-form">
        <div className='title' style={{textTransform:'uppercase', color:'#7D7D7D', fontWeight:'600',margin:'10px'}}>Configure</div>
        <div className="name">
          <FormGroup>
            <div className='apiKey'>
              <label className='apiKey'>API-KEY:</label>
              <Input
                id="open_ai_key"
                name="open_ai_key"
                placeholder="Enter Api Key"
                // type='password'
                value={formValues?.open_ai_key}
                autoComplete='off'
                onChange={(e) => setValues(e?.target?.value, "open_ai_key")}
              >
              </Input>
            </div>
          </FormGroup>
        </div>
        <div  className="input-group">
          <div className="name">
            <FormGroup>
              <Label for="engine">Engine</Label>
              {/* <div className='context'>
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> */}
              <Input
                id="engine"
                name="engine"
                placeholder="Choose LLMs"
                type="select"
                value={formValues?.engine}
                onChange={(e) => setValues(e?.target?.value, "engine")}
              >
                {displayEngines()}
              </Input>
            </FormGroup>
          </div>
          <div className="name">
            <FormGroup>
              <Label for="model_name">Model</Label>
              {/* <div className='context'>
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> */}
              <Input
                id="model_name"
                name="model_name"
                type="select"
                placeholder="Please enter the name"
                value={formValues?.model_name}
                onChange={(e) => setValues(e?.target?.value, "model_name")}
              >
                {displayModels()}
              </Input>
            </FormGroup>
          </div>
        </div>
        <div className="input-group">
          <div className="name">
            <FormGroup>
              <Label for="embeddedModal">Embedded Modal</Label>
              {/* <div className='context'>
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> */}
              <Input
                id="embeddedModal"
                name="embeddedModal"
                placeholder="Please enter the name"
                type='select'
                value={formValues?.embeddedModal}
                onChange={(e) => setValues(e?.target?.value, "embeddedModal")}
              >
                {displayEmbeddedModels()}
              </Input>
            </FormGroup>
          </div>
          <div className="name">
            <FormGroup>
              <Label for="temperature">temperature {formValues?.temperature}</Label>
              {/* <div className='context'>
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> */}
              <Input
                id="temperature"
                name="temperature"
                type='range'
                placeholder="Please enter the name"
                min={1}
                max={10}
                value={formValues?.temperature * 10}
                onChange={(e) => setValues(e?.target?.value, "temperature")}
              />
            </FormGroup>
          </div>
        </div>
        <div className="input-group">
          <div className="name">
            <FormGroup>
              <Label for="chunk_overlap">chunk Overlap {formValues?.chunk_overlap}</Label>
              {/* <div className='context'>
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> */}
              <Input
                id="chunk_overlap"
                name="chunk_overlap"
                type='range'
                placeholder="Please enter the name"
                min={250}
                max={5000}
                value={formValues?.chunk_overlap}
                onChange={(e) => setValues(e?.target?.value, "chunk_overlap")}
              />
            </FormGroup>
          </div>
          <div className="name">
            <FormGroup>
              <Label for="chunk_size">chunk Size {formValues?.chunk_size}</Label>
              {/* <div className='context'>
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> */}
              <Input
                id="chunk_size"
                name="chunk_size"
                type='range'
                placeholder="Please enter the name"
                min={250}
                max={5000}
                value={formValues?.chunk_size}
                onChange={(e) => setValues(e?.target?.value, "chunk_size")}
              />
            </FormGroup>
          </div>
        </div>
        <div className="btns2">
          {/* <Button className="cancel" onClick={() => toggleSettingsModal()}>
            Cancel
          </Button> */}
          <Button className="submit attr-submit"
            onClick={() => configSubmit()}
          >
            Save
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default Settings